export interface IVerifyAddressDtoRequest
{
  addressLine1: string;
  addressLine2: string;
  townCity: string;
  countyState: string;
  postalCode: string;
  country: string;
  countryCode: string;
}
	
export interface IVerifyAddressDtoResponse extends IVerifyAddressDtoRequest
{
    qualityIndex: string,
    matchScore: number;
}

export interface IAddressDetailsDtoRequest
{
  country: string;
  address: string;
}

export interface IAddressDetailsDtoResponse
{
  addressLine1: string;
  addressLine2: string;
  townCity: string;
  countyState: string;
  postalCode: string;
  country: string;
  countryCode: string;
  countryName: string;
}


/*
let foundAddress = JSON.parse(res);
      let addressToEmit = {

        //update address fields with search result - takes place in ng-repeat scope so use $scope
        addressLine1: foundAddress.DeliveryAddress1,
        addressLine2: null,
        townCity: foundAddress.Locality,
        countyState: foundAddress.AdministrativeArea,
        postalCode: foundAddress.PostalCode,
        countryName: foundAddress.CountryName,
        country_Code: foundAddress['ISO3166-2']

      };
      
      addressToEmit.countryName = addressToEmit.countryName.toUpperCase()
      
      if (addressToEmit.country_Code == 'GR') {
        addressToEmit.country_Code = 'EL';
      }

      //add line 2 if the found addresses line1 doesn't match
      if(foundAddress.DeliveryAddress2 != foundAddress.Locality){
        addressToEmit.addressLine2 = foundAddress.DeliveryAddress2;
      }      
      this.selectedAddress.emit(addressToEmit);
      delete this.feedback;*/